var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 20.89C18.354 20.613 21.686 17.233 21.96 12.99C22.013 12.16 22.013 11.3 21.96 10.47C21.686 6.228 18.354 2.85 14.17 2.571C12.7249 2.47576 11.2751 2.47576 9.82997 2.571C5.64597 2.849 2.31397 6.228 2.03997 10.471C1.987 11.3102 1.987 12.1518 2.03997 12.991C2.13997 14.536 2.82297 15.967 3.62797 17.175C4.09497 18.02 3.78697 19.075 3.29997 19.998C2.94997 20.663 2.77397 20.995 2.91497 21.235C3.05497 21.475 3.36997 21.483 3.99897 21.498C5.24397 21.528 6.08297 21.176 6.74897 20.685C7.12597 20.406 7.31497 20.267 7.44497 20.251C7.57497 20.235 7.83197 20.341 8.34397 20.551C8.80397 20.741 9.33897 20.858 9.82897 20.891C11.254 20.985 12.743 20.985 14.171 20.891L14.17 20.89Z",
    fill: "url(#paint0_linear_45_2277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.538C10.5 8.688 11.172 8 12 8C12.828 8 13.5 8.689 13.5 9.538C13.5 9.845 13.413 10.13 13.262 10.37C12.814 11.084 12 11.766 12 12.615V13",
    stroke: "#180749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H12.009",
    stroke: "#180749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2277",
    x1: 2.00024,
    y1: 11.9997,
    x2: 21.9997,
    y2: 11.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F466C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportActive);
export default __webpack_public_path__ + "static/media/support-active.601e2fc848725c0b8fbf64499c251b5d.svg";
export { ForwardRef as ReactComponent };